import USPs from './AppointmentUSPBlock/USPs'
import ContactForm from './_contact/ContactForm'
import { Container } from './gassan-ui'
import { LeadStore } from '@generated'
import pinterestTracking from '@lib/pinterest-tracking'
import React, { FC } from 'react'

type TudorContactFormProps = {
  subject: string
  productId: string
}

export const TudorContactForm: FC<TudorContactFormProps> = ({ subject, productId }) => {
  return (
    <div className="relative mt-40 w-full pt-12 lg:pt-14">
      <div className="absolute left-0 top-0 h-1/4 w-full bg-shade-50" />
      <Container maxWidth="90rem" className="relative">
        <USPs />
        <div className="md:lg-12 relative mx-auto w-full max-w-[60rem] bg-pampas px-4 py-8 lg:py-20">
          <div className="mx-auto w-full max-w-[35rem]">
            <ContactForm
              subject={subject}
              leadStore={LeadStore.Gassan}
              onSubmitSuccess={(values) => {
                if (productId) {
                  pinterestTracking.lead({
                    lead_type:
                      values.type === 'APPOINTMENT' ? 'product-appointment' : 'product-question',
                    product_id: productId,
                  })
                }
              }}
            />
          </div>
        </div>
      </Container>
    </div>
  )
}
